<script lang="ts">
    import type { IconType } from "@components/material/Icon.module"

    import Icon from "@components/material/Icon.svelte"
    export let icon : IconType
</script>
<Icon {icon} class="h-[1em]" />